<!-- <div *ngIf="!ispopUpShow" class="modal videoModal fade " id="videoModal">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">  -->
<!-- Modal body -->
<!-- <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal"><i class="icon-close"></i></button>
                <div width="400" id="myDiv"></div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div *ngIf="!isInPopup" width="400" class="vedioControls" id="myDiv"></div> -->




<!-- Popup -->
<!-- <div class="popup-main popup--overlay">
    <div class="popup">
    <button class="popup--close" href=""><span class="icon-cross"></span></button>
        
        <div class="popup__content">
            <h2>Program Block Introductory Video 1</h2>
        <p>It is a long established fact that a reader will be distracted by the readable
            content of a page when looking at its layout.</p>
            <img src="assets/images/video.PNG" alt="" />
            <button class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">
                START COURSE
            </button>
        </div>
    </div>
</div> -->

<div class="popup-main popup--overlay" *ngIf="!ispopUpShow" style="display: flex;">
    <div class="popup">

        <button class="popup--close"><span class="icon-close1" (click)="closePop()"></span></button>

        <div class="popup__content">
            <ng-container *ngIf="type == 'PROGRAM'">
                <h2>{{ videoTitle | titlecase }}</h2>
                <p *ngIf="videoDesc">{{ videoDesc }}</p>
            </ng-container>
            <ng-container *ngIf="(type == 'COURSE') || (type == 'INTEGRATION')">
                <ng-container *ngIf="item?.introVideoTitle">
                    <h2>{{ videoTitle | titlecase }}</h2>
                    <p *ngIf="videoDesc">{{ videoDesc }}</p>
                </ng-container>
                <ng-container *ngIf="!item?.introVideoTitle && item?.title">
                    <h2>Introduction to {{ item?.title | titlecase }}</h2>
                    <p *ngIf="videoDesc">{{ item?.description }}</p>
                </ng-container>
                
            </ng-container>
            <ng-container *ngIf="type == 'MASTERCLASS'">
                <h2>{{ videoTitle | titlecase }} - Recording</h2>
                <p *ngIf="videoDesc">{{ videoDesc }}</p>
            </ng-container>
            <!-- video-question-player: class to hide video controls  -->
            <div class="player" *ngIf="type != 'MASTERCLASS'">
                <video id="myDiv" width="670" height="350" controls>
                    <source [src]="_file" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div class="player" *ngIf="type == 'MASTERCLASS'">
                <video id="myDiv" width="670" height="350" controls>
                    <source [src]="_file" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <!-- <video id="myDiv" width="670" height="350" controls *ngIf="type == 'MASTERCLASS'">
                <source [src]="_file" type="video/mp4">
                Your browser does not support the video tag.
            </video> -->
            <!-- <div width="400" id="myDiv"></div> -->
            <button *ngIf="programIntroVideo"
                class="light-color link-no-underline blue--button pd-t5 pd-b5 pd-l15 pd-r15" (click)="closePop()">
                GO TO DASHBOARD
            </button>
            <button *ngIf="programEndVideo"
                class="light-color link-no-underline blue--button pd-t5 pd-b5 pd-l15 pd-r15" (click)="closePop()">
                NEXT
            </button>
            <button *ngIf="showButton" class="light-color link-no-underline blue--button pd-t5 pd-b5 pd-l15 pd-r15"
                (click)="msgToParent()">
                {{footerBtnText}}
            </button>
        </div>
    </div>